<template>
  <v-container class="no-margins">
    <ActionButton class="mt-4" actionIcon="$sl-bankid" @click="doExternalLogin()">{{ buttonText }}</ActionButton>
  </v-container>
</template>

<script>
import API from '@/services/api'
import ActionButton from '@/components/Common/ActionButton'
// @group Common
// BankIdLoginButton component
export default {
  name: 'BankIdLoginButton',

  props: {
    //Action button text
    buttonText: {
      // `true` / `false`
      type: String,
      required: true
    }
  },

  components: {
    ActionButton
  },

  methods: {
    /**
     * @vuese
     * Used to do login
     * @arg the argument is a hash
     */
    doExternalLogin() {
      console.log('LoginDeck - doExternalLogin')

      API.bankIdExternal({
        callback: Buffer.from(window.location.protocol + '//' + window.location.host + '/loginreturn').toString(
          'base64'
        )
      })
        .then(res => {
          if (res.data.redirectUrl) {
            window.location = res.data.redirectUrl
          }
        })
        .catch(err => {
          console.log('Error: ', err)
        })
    }
  }
}
</script>

<style scoped>
</style>